import React, { useEffect } from 'react';
import { Wrapper, ContentWrapper } from './styled';

interface ScrollSpyProps {
  children?: React.ReactNode;
}

function ScrollSpy({ children }: ScrollSpyProps) {
  const handleClick = (element: HTMLElement, e: PointerEvent) => {
    e.preventDefault();

    const spiedComponent = document.getElementById(`${element.dataset.spy}`);
    window.scrollTo({
      top: spiedComponent.offsetTop,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    const tabList = document.querySelectorAll('li[data-spy]');

    tabList.forEach((list: HTMLElement) => {
      const spiedComponent = document.getElementById(`${list.dataset.spy}`);
      const link = list.querySelector('a');
      if (spiedComponent) {
        if (window.scrollY >= spiedComponent.offsetTop) {
          document.querySelector('.active').classList.remove('active');
          list.classList.add('active');
        }
      } else {
        return;
      }

      // @ts-ignore
      link.addEventListener('click', (event) => handleClick(list, event));
    });
  };

  const handleToggleActive = () => {
    const scrollSpy = document.getElementById('scroll-spy');
    const { scrollY } = window;
    const isActive = scrollSpy.classList.contains('down');

    if (scrollY < 450) {
      scrollSpy.classList.remove('down');
    } else if (!isActive) {
      scrollSpy.classList.add('down');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleToggleActive);

    return () => {
      window.removeEventListener('scroll', handleToggleActive);
    };
  }, []);

  // scroll spy effect
  useEffect(() => {
    const tabList = document.querySelectorAll('li[data-spy]');
    tabList[0].classList.add('active');
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Wrapper id="scroll-spy">
      <ContentWrapper>{children}</ContentWrapper>
    </Wrapper>
  );
}

export default ScrollSpy;
